const errors = {
  BLADEWALLLET_SIGNER_NOT_INIT: "Signer not initialized",
};

export default errors;
